import React from "react";
// import smiley from "assets/smily.png";
import { withPage } from "hoc/WithPages";

const FAQs = () => (
	<div>
		<h1 className="text-4xl font-bold mb-4">
			FAQ’s<span className="text-primary">.</span>
		</h1>
		<div className="mb-48">
			<p>FAQ’s page placeholder</p>
		</div>
	</div>
);

export default withPage(FAQs);
